import script from "./VaultsList.vue?vue&type=script&setup=true&lang=ts"
export * from "./VaultsList.vue?vue&type=script&setup=true&lang=ts"

import "./VaultsList.vue?vue&type=style&index=0&id=3d6a7c60&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/curl-fe-build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3d6a7c60"]])

export default __exports__